import { render } from "./port-fileupload-message.vue?vue&type=template&id=2953e7b0"
import script from "./port-fileupload-message.vue?vue&type=script&lang=js"
export * from "./port-fileupload-message.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__